import React from 'react';
import { useLocation } from 'react-router';

import { PageRoot } from '@/components/layout/page';

/**
 * AI.GEN lines=1-15
 * 页面内容组件 - 简化版本，保留路由功能
 */
export const PageContent = () => {
  const location = useLocation();

  return (
    <div className="overflow-hidden flex-column">
      <PageRoot pathname={location.pathname}></PageRoot>
    </div>
  );
};
